import { computed, defineAsyncComponent, defineComponent, ref } from 'vue';
import AppointmentFormComponent from '@/components/appointmentForm/AppointmentForm.vue';

export default defineComponent({
  name: 'AppointmentDocumentPage',
  components: {
    AppointmentFormComponent,
    AsyncAppointmentTableComponent: defineAsyncComponent(() => import('@/components/appointmentTable/AppointmentTable.vue')),
    AsyncAppointmentDetailComponent: defineAsyncComponent(() => import('@/components/appointmentDetail/AppointmentDetail.vue')),
  },
  setup: () => {
    const appointmentId = ref<number | null>(null);
    const appointmentForm = ref<InstanceType<typeof AppointmentFormComponent>>();
    const appointmentComponent = computed(() => `async-appointment-${appointmentId.value ? 'detail' : 'table'}-component`);

    const toggleAppointment = (id: number | null) => {
      appointmentId.value = id;
    };

    const show = () => {
      appointmentForm.value?.show();
    };

    return {
      appointmentId,
      appointmentForm,
      appointmentComponent,
      toggleAppointment,
      show,
    };
  },
});
